import AddIcon from "@mui/icons-material/Add";
import { useDialog } from "../hooks/useDialog";
import { Button, type SxProps } from "@mui/material";
import { AddAppointmentDialog } from "../dialogs/AddAppointmentDialog/AddAppointmentDialog";
import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";

export function AddSimulatorDrivingLessonButton(props: { sx?: SxProps }) {
  const { sx } = props;
  const { dialogProps, openDialog } = useDialog("AddSimulatorDrivingLessonDialog");
  const student = useRecordContext<Student>();

  if (!student) {
    return null;
  }

  return (
    <>
      <Button startIcon={<AddIcon />} sx={sx} variant="outlined" onClick={openDialog}>
        Simulator-Fahrstunde
      </Button>
      <AddAppointmentDialog student={student} tabs={["simulatorDrivingLesson"]} {...dialogProps} />
    </>
  );
}
